import React, { useEffect, useState } from 'react';
import ContentList from '../../../components/public/content/ContentList';
import PageHeader from '../../../components/public/common/PageHeader';
import Layout from '../../../components/public/common/Layout';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { getContentPagesByCategory } from '../../../services/contentPageService';

const ContentListPage = ({ category }) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getContentPagesByCategory(category);
        
        if (!data) {
          throw new Error('No pages found');
        }

        setPages(data);
      } catch (error) {
        console.error('Error fetching pages:', error);
        setError(error.message || 'Failed to fetch pages');
      } finally {
        setLoading(false);
      }
    };

    if (category) {
      fetchPages();
    }
  }, [category]);

  const getPageHeaderProps = () => {
    if (category === 'legal') {
      return {
        title: 'Legal Documents',
        description: 'Access our legal documents and policies',
        backgroundImage: '/images/legal-header.jpg'
      };
    }
    return {
      title: 'Support Center',
      description: 'Find help and support for your questions',
      backgroundImage: '/images/support-header.jpg'
    };
  };

  return (
    <Layout>
      <PageHeader {...getPageHeaderProps()} />
      
      {error && (
        <div className="container mx-auto px-6 py-8">
          <div className="text-red-500 text-center mb-4 dark:text-red-400">
            {error}
          </div>
        </div>
      )}

      {loading ? (
        <div className="flex justify-center items-center py-8">
          <LoadingSpinner size="lg" text="Loading pages..." />
        </div>
      ) : (
        <ContentList pages={pages} category={category} />
      )}
    </Layout>
  );
};

export default ContentListPage; 